export default __webpack_public_path__ + "static/ti_car_block-cb9a3096630a852f7b38a4f3a27d70b6.svg";